"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CustomSwitch = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactSwitch = _interopRequireDefault(require("react-switch"));
require("./style.sass");
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}

/*
  Lib react-switch
  https://www.npmjs.com/package/react-switch
*/
var CustomSwitch = function CustomSwitch(_ref) {
  var _ref$height = _ref.height,
    height = _ref$height === void 0 ? 24 : _ref$height,
    _ref$width = _ref.width,
    width = _ref$width === void 0 ? 40 : _ref$width,
    _ref$onColor = _ref.onColor,
    onColor = _ref$onColor === void 0 ? '#21A038' : _ref$onColor,
    _ref$offColor = _ref.offColor,
    offColor = _ref$offColor === void 0 ? '#CDD2D6' : _ref$offColor,
    _ref$uncheckedIcon = _ref.uncheckedIcon,
    uncheckedIcon = _ref$uncheckedIcon === void 0 ? false : _ref$uncheckedIcon,
    _ref$checkedIcon = _ref.checkedIcon,
    checkedIcon = _ref$checkedIcon === void 0 ? false : _ref$checkedIcon,
    _ref$handleDiameter = _ref.handleDiameter,
    handleDiameter = _ref$handleDiameter === void 0 ? 12 : _ref$handleDiameter,
    props = _objectWithoutProperties(_ref, ["height", "width", "onColor", "offColor", "uncheckedIcon", "checkedIcon", "handleDiameter"]);
  return /*#__PURE__*/_react.default.createElement(_reactSwitch.default, _extends({
    width: width,
    height: height,
    onColor: onColor,
    offColor: offColor,
    uncheckedIcon: uncheckedIcon,
    checkedIcon: checkedIcon,
    handleDiameter: handleDiameter
  }, props));
};
exports.CustomSwitch = CustomSwitch;